import { RemoteAuthSignOut } from 'data/usecases';
import { AuthSignOut } from 'domain/usecases';
import { makeApiUrlAuthSignOut } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteAuthSignOut = (): AuthSignOut => {
  return new RemoteAuthSignOut(makeApiUrlAuthSignOut(), makeAxiosHttpClient());
};
